export enum TypicalFuncLabelEnum {
  BRK = 'trip relay',
  FD = 'relay',
  FE = 'trigger',
  FWP = 'relay',
  MOT = 'relay',
  NFS = 'output signal',
  VLV = 'solenoid',
  VLV_P = 'solenoid (PS)',
}
